import React from "react";
import { UserProvider } from "./provider/UserContext";
import DisplayUsers from "./DisplayUsers";

const index = () => {
  return (
    <UserProvider>
      <DisplayUsers />
    </UserProvider>
  );
};

export default index;
